import { Button, SecondaryButton } from '@chegg-ui/button'
import { colors, font, spacing } from '@chegg-ui/theme'
import styled from 'styled-components'

export const SynonymErrorContainer = styled.div`
  margin: ${spacing.px4} ${spacing.px24} 0 ${spacing.px24};
`
export const SynonymErrorButton = styled(SecondaryButton).attrs({
  variant: 'text',
})`
  padding: 0;
  font-size: ${font.size.px14};
  font-weight: ${font.weight.normal};
  text-decoration: underline;
  &&& {
    color: ${colors.grey900};
    :hover {
      background: none;
    }
  }
`

export const SuggestionTitle = styled.span<{ hasError?: boolean }>`
  color: ${({ hasError }) => hasError && colors.grey400};
  overflow-wrap: anywhere;
`

export const RewriteErrorContainer = styled.div`
  margin-top: 0;
`

export const RewriteErrorButton = styled(SynonymErrorButton)`
  margin-left: ${spacing.px4};
  font-weight: ${font.weight.medium};
`

export const TryAgain = styled(Button)`
  margin: ${spacing.px32} 0 0 0;
  font-size: ${spacing.px16};
  font-weight: normal;
  height: ${spacing.px32};
  &&& {
    background: ${colors.grey900};
  }
`
